import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Avoid loading twice
    if ((window as any).fbq) return;
    const f = window as any;
    const b = document;
    let n: any;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = b.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    (window as any).fbq('init', '2043786956475160');
    (window as any).fbq('track', 'PageView');
    // Add noscript fallback
    const noscript = b.createElement('noscript');
    const img = b.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2043786956475160&ev=PageView&noscript=1';
    noscript.appendChild(img);
    b.body.appendChild(noscript);
  }, []);
  return null;
}